<template>
  <div class="shufoo">
    <div class="shufoo__item">
      <div class="shufoo__info">
        <p class="shufoo__name">{{ $t('pages.CompaniesLocationStore.shufooAttributes.latitude') }}</p>
        <p class="shufoo__content">{{ attributes.latitude }}</p>
        <p class="shufoo__name">{{ $t('pages.CompaniesLocationStore.shufooAttributes.longitude') }}</p>
        <p class="shufoo__content">{{ attributes.longitude }}</p>
      </div>
    </div>
    <div class="shufoo__item">
      <div class="shufoo__info">
        <p class="shufoo__name">{{ $t('pages.CompaniesLocationStore.shufooAttributes.publishStatus') }}</p>
        <p class="shufoo__content">{{ attributes.publishStatus ? $t('pages.CompaniesLocationStoreShufooEdit.publishStatus.kind.' + attributes.publishStatus) : '' }}</p>
      </div>
    </div>
    <div class="shufoo__item">
      <div class="shufoo__info">
        <p class="shufoo__name">{{ $t('pages.CompaniesLocationStore.shufooAttributes.businessHoursCaption') }}</p>
        <p class="shufoo__content">{{ attributes.businessHoursCaption }}</p>
      </div>
    </div>
    <div class="shufoo__item">
      <div class="shufoo__info">
        <p class="shufoo__name">{{ $t('pages.CompaniesLocationStore.shufooAttributes.code') }}</p>
        <p class="shufoo__content">{{ attributes.code }}</p>
      </div>
    </div>
    <div class="shufoo__item">
      <div class="shufoo__info">
        <p class="shufoo__name">{{ $t('pages.CompaniesLocationStore.shufooAttributes.referralUrl') }}</p>
        <p class="shufoo__content">{{ attributes.referralUrl }}</p>
      </div>
    </div>
    <div v-if="isEditable" class="c-button c-button--right">
      <router-link
        :to="{ name: 'CompaniesLocationStoreShufooEdit', params: { company_uuid: companyUuid, store_uuid: storeUuid } }"
        class="c-button__item c-button__item--primary"
      >
        {{ $t('labels.change') }}
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SiteSettingsShufoo',
  props: {
    attributes: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    companyUuid() {
      return this.$route.params.company_uuid
    },
    storeUuid() {
      return this.$route.params.store_uuid
    }
  }
}
</script>

<style lang="scss" scoped>
.shufoo {
  &__item {
    display: flex;
    justify-content: space-between;
    padding: 0 32px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  &__info {
    padding: 24px 0;
  }
  &__name {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
  &__content {
    font-size: 14px;
    line-height: 1.5;
  }
  .c-button {
    align-self: center;
    margin-top: 0;
    padding: 32px 0;
    &__item {
      margin: 0;
    }
  }
}
</style>
